var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 56,
    viewBox: "0 0 327 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4414 3.20227C45.2393 -1.10222 267.825 -0.997851 303.23 3.09794C338.641 7.19373 331.753 49.1169 300.566 52.8931C263.366 57.4063 43.4962 57.1323 20.6983 51.2169C-6.1473 44.271 -8.22992 8.98073 22.4349 3.20227H22.4414Z",
    fill: "#0F97D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6405 5.20446C47.9356 1.34998 265.619 1.44128 300.253 5.11314C334.881 8.78501 328.15 46.3385 297.648 49.7234C261.264 53.767 46.2382 53.5191 23.943 48.2233C-2.65448 41.9948 -4.52166 10.3894 25.6405 5.20446Z",
    fill: "#A3E3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.c74d5ec716531c6691ce1493e7d346e8.svg";
export { ForwardRef as ReactComponent };